function getBasePath() {
  var directoryArray = window.location.pathname.split('/');
  directoryArray.pop();
  return directoryArray.join('/');
}

function getSearchParams() {
  return window.location.search.substring(1).split('&').filter(e => e).reduce((acc, e) => {
    const [key, value] = e.split('=');
    acc[key] = value;
    return acc;
  }, {});
}

function getLanguage() {
  return getSearchParams().languageCode || 'fr';
}

function redirect() {
  // use replace as URIdecode ignores the java encoding
  var redirectUrl = getSearchParams().redirect;
  window.location.replace(redirectUrl && redirectUrl.replace(/%3D/g, '='));
}

export { getBasePath, getSearchParams, getLanguage, redirect };